import React from 'react';

import APModal from 'components/Modal/APModal';

export const ForbiddenModal = () => {
  const handleModalDismiss = () => {
     window.location.href = '/app';
  };

  return (
    <APModal
      open
      title="Uh oh! There's a teeny problem."
      onClose={handleModalDismiss}
      actions={(
        <button
          className="button"
          onClick={handleModalDismiss}
        >
          Got it
        </button>
      )}
    >
      <p>
        It looks like you don’t have permission to access this page.
        If you believe you’re receiving this message in error, reach out
        to your account owner or connect with Aisle Planner customer support
        &nbsp;<a
          href="https://www.aisleplanner.com/contact-us-pro"
          target="_blank"
          rel="noreferrer noopener"
        >here</a>.
      </p>
    </APModal>
  );
};
